import React from 'react';
import HealthcareAgentAddressInput from './HealthcareAgentAddressInput';

export default class SpouseHealthcareAgentAddressInput extends HealthcareAgentAddressInput {
  static forSpouse = true;
}
